(function() {
  const THRESHOLD = 20000;
  function updateBar(cart) {
    const bar = document.getElementById('free-shipping-bar');
    if (!bar) return;
    const remaining = Math.max(THRESHOLD - cart.total_price, 0);
    const percent = Math.min((cart.total_price / THRESHOLD) * 100, 100);
    const fill = bar.querySelector('.free-shipping-bar__fill');
    const text = bar.querySelector('.free-shipping-bar__text');
    if (fill) fill.style.width = percent + '%';
    if (text) {
      text.classList.toggle('free-shipping-bar__text--success', remaining === 0);
      text.innerHTML = remaining > 0
        ? `Te faltan <strong>S/ ${(remaining/100).toFixed(2)}</strong> para envío GRATIS 🚚`
        : '¡Envío GRATIS desbloqueado! 🎉';
    }
  }
  function refreshCart() {
    fetch('/cart.js').then(r => r.json()).then(updateBar);
  }
  document.addEventListener('DOMContentLoaded', refreshCart);
  document.addEventListener('cart:updated', refreshCart);
  document.body.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-icon], cart-icon, [href="/cart"]')) {
      setTimeout(refreshCart, 300);
    }
  });
})();